var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpushdelivered(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.972656,
    y: 0.800781,
    width: 43.4019,
    height: 43.4019,
    rx: 6,
    fill: "#71C04D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1719 22.5C32.1719 27.7467 27.9186 32 22.6719 32C17.4252 32 13.1719 27.7467 13.1719 22.5C13.1719 17.2533 17.4252 13 22.6719 13C27.9186 13 32.1719 17.2533 32.1719 22.5ZM21.573 27.5302L28.6214 20.4818C28.8607 20.2424 28.8607 19.8544 28.6214 19.615L27.7547 18.7483C27.5153 18.5089 27.1272 18.5089 26.8878 18.7483L21.1396 24.4965L18.4559 21.8127C18.2166 21.5734 17.8285 21.5734 17.5891 21.8127L16.7223 22.6795C16.483 22.9188 16.483 23.3069 16.7223 23.5463L20.7062 27.5301C20.9456 27.7695 21.3336 27.7695 21.573 27.5302Z",
    fill: "#16A34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpushdelivered);
export default __webpack_public_path__ + "static/media/fullpushdelivered.ebdfafbfd193c5b5148b5f5b67cf602e.svg";
export { ForwardRef as ReactComponent };